// Window-event names used to talk across module boundaries.
//
// `OPEN_GLOBAL_SEARCH` is dispatched by the topbar's mobile search button and
// listened for by the Search module's SearchBox. It is a contract between the
// two, not Search's private export — keeping it here is what lets the shared
// header stop importing the Search feature (#33).
export const OPEN_GLOBAL_SEARCH = 'global-search:open'
